/*
* Configuration for Designer
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()

  return {
    quoteFormEnable: true, // Enable Quote forn in Designer
    tabs: {
      designTab: {
        enable: true,
        artworkLimit: 5, // Limit on side = (maxArtworksCount * restrictions count),
        showHelp: true,
        optionsType: 'modal', // modal/sidebar
        showSideSwitchOnModal: true,
        actionBtns: {
          continue: {
            enable: true,
            buttonTitle: i18n?.t('continue'),
            buttonClasses: 'secondary-color base-1'
          },
          skip: {
            enable: true,
            buttonTitle: i18n?.t('skipAndArtworkLater'),
            buttonClasses: 'btn-flat skip'
          }
        },
        sidebarActionInfoLine: true
      },
      specTab: {
        enable: true,
        title: {
          order: i18n?.t('selectYourProductFeatures'),
          quote: i18n?.t('selectYourProductFeatures')
        },
        descr: {
          order: false,
          quote: i18n?.t('pleaseFillOutTheForm')
        }
      },
      addOnTab: {
        enable: true,
        title: {
          order: i18n?.t('getMorePersonal'),
          quote: i18n?.t('getMorePersonal')
        },
        descr: {
          order: i18n?.t('designerAddonsDescr'),
          quote: i18n?.t('designerAddonsDescr')
        }
      },
      infoTab: {
        enable: true,
        title: {
          order: i18n?.t('finalizeYourOrder'),
          quote: false
        },
        descr: {
          order: false,
          quote: false
        },
        howWillYouBeUsingThisProductEnable: true
      }
    },
    timeStripeEnable: true,
    receipt: {
      parentStyle: 'defaultStyle',
      totalLabel: i18n?.t('totalPrice'),
      showFreeShip: true,
      disclaimer: i18n?.t('pricesAndProductAvailability'),
      actionBtns: {
        continue: {
          enable: true,
          buttonTitle: i18n?.t('continue'),
          buttonClasses: 'secondary-color base-1'
        },
        addToCart: {
          enable: true,
          buttonTitle: i18n?.t('addToCart'),
          buttonClasses: 'secondary-color base-1'
        }
      }
    }
  }
}
